import api from './index';

const apiPath = '/api/v1';
const basePath = (id) => `${apiPath}/subscriptions/${id}`;

export default {
  addSubscription(data, entityId) {
    return api({
      method: 'post',
      url: `${apiPath}/entities/${entityId}/subscriptions`,
      data,
    });
  },
  updateSubscription(subscriptionId, data) {
    return api({
      method: 'patch',
      url: `${basePath(subscriptionId)}`,
      data,
    });
  },
  destroySubscription(subscriptionId) {
    return api({
      method: 'delete',
      url: basePath(subscriptionId),
    });
  },
};
